export default __webpack_public_path__ + "static/media/banner1.b20b2598.svg";